var ROUTE_MANIFEST = "_MODERNJS_ROUTE_MANIFEST";
var ROUTE_MODULES = "_routeModules";
var HMR_SOCK_PATH = "/webpack-hmr";
var HTML_CHUNKSMAP_SEPARATOR = "<!--<?- chunksMap.js ?>-->";
var LOADER_REPORTER_NAME = "server-loader";
var ROUTE_SPEC_FILE = "route.json";
var NESTED_ROUTE_SPEC_FILE = "nestedRoutes.json";
var MAIN_ENTRY_NAME = "main";
var SERVER_BUNDLE_DIRECTORY = "bundles";
var SERVER_RENDER_FUNCTION_NAME = "serverRender";
var SERVER_PLUGIN_BFF = "@modern-js/plugin-bff";
var SERVER_PLUGIN_EXPRESS = "@modern-js/plugin-express";
var SERVER_PLUGIN_KOA = "@modern-js/plugin-koa";
var SERVER_PLUGIN_SERVER = "@modern-js/plugin-server";
var SERVER_PLUGIN_POLYFILL = "@modern-js/plugin-polyfill";
export {
  HMR_SOCK_PATH,
  HTML_CHUNKSMAP_SEPARATOR,
  LOADER_REPORTER_NAME,
  MAIN_ENTRY_NAME,
  NESTED_ROUTE_SPEC_FILE,
  ROUTE_MANIFEST,
  ROUTE_MODULES,
  ROUTE_SPEC_FILE,
  SERVER_BUNDLE_DIRECTORY,
  SERVER_PLUGIN_BFF,
  SERVER_PLUGIN_EXPRESS,
  SERVER_PLUGIN_KOA,
  SERVER_PLUGIN_POLYFILL,
  SERVER_PLUGIN_SERVER,
  SERVER_RENDER_FUNCTION_NAME
};
